import React, { useState } from 'react';
import { AiOutlineArrowUp } from 'react-icons/ai';
import { FaPaperPlane } from 'react-icons/fa';
import logo from '../../assets/img/Vedant-Tech-Logo-Transparent.png';
import WidgetAbout from './WidgetAbout';
import WidgetGetinTouch from './WidgetGetinTouch';
import WidgetGetinTouchData from './WidgetGetinTouchData';
import WidgetNews from './WidgetNews';
import WidgetNewsData from './WidgetNewsData';
import { Link } from 'react-router-dom';

function Footer1() {
    // STATES
    const [email, setEmail] = useState('');

    // HANDLER
    const onchangeHandler = (e) => {
        setEmail(e.target.value);
    };
    const onSubmitHandler = (e) => {
        e.preventDefault();
    };
    return (
        <footer className="footer-1 footer-wrap">
            <div className="footer-widgets dark-bg">
                <div className="container">
                    <div className="row">
                        {/* ABOUT WIDGET */}
                        <WidgetAbout
                            text="Vedant Technology is an engineering and manufacturing solutions company providing end-to-end support from new product development to mass production. We specialize in product development, vendor development, manufacturing support, quality audits, and cost optimization across multiple manufacturing processes."
                            fbLink="/"
                            twitterLink="/"
                            instaLink="/"
                            youtubeLink="/"
                        />

                        {/* NEWS FEED WIDGET */}

                        {/* <div className="col-md-6 col-xl-4 col-12">
                            <div className="single-footer-wid recent_post_widget">
                                <div className="wid-title">
                                    <h4>News Feeds</h4>
                                </div>
                                <div className="recent-post-list">
                                    {WidgetNewsData.map((data) => (
                                        <WidgetNews
                                            key={data.id}
                                            thumbnail={data.thumbnail}
                                            meta={data.meta}
                                            heading={data.heading}
                                            link={data.link}
                                        />
                                    ))}
                                </div>
                            </div>
                        </div> */}

                        {/* Sitemap WIDGET */}
                        <div className="col-md-6 col-xl-4 col-12 d-flex justify-content-start justify-content-md-center">
                            <div className="single-footer-wid newsletter_widget">
                                <div className="wid-title">
                                    <h4>Site Map</h4>
                                </div>
                                <div className="newsletter_box ">
                                   <Link to="/"><li className='mb-2'>Home</li></Link>
                                   <Link to="/about"><li className='mb-2'>About</li></Link>
                                   <Link to="/services"><li className='mb-2'>Services</li></Link>
                                   <Link to="/products"><li className='mb-2'>Products</li></Link>
                                   <Link to="/contact"><li className='mb-2'>Contact</li></Link>
                                    {/* <p>
                                        Subscribe our newsletter to get our latest updates &#38;
                                        news.
                                    </p>
                                    <form action="#">
                                        <input
                                            value={email}
                                            onChange={onchangeHandler}
                                            type="email"
                                            placeholder="Enter email address"
                                            required
                                        />
                                        <button
                                            className="submit-btn"
                                            type="submit"
                                            onSubmit={onSubmitHandler}
                                        >
                                            <FaPaperPlane />
                                        </button>
                                    </form> */}
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 col-xl-4 col-12">
                            <div className="single-footer-wid ml-15 site_info_widget">
                                <div className="wid-title">
                                    <h4>Get In Touch</h4>
                                </div>
                                <div className="contact-us" />
                                {WidgetGetinTouchData.map((data) => (
                                    <WidgetGetinTouch
                                        key={data.id}
                                        icon={data.icon}
                                        heading={data.heading}
                                        text={data.text}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Footer bottom */}
            <div className="footer-bottom">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-4 col-12 order-2 order-lg-1">
                            <div className="copyright-info">
                                <p className='text-white'>
                                    Developed By <a href="https://www.variantspark.com" target="_blank">Variant Spark</a> 
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-12 text-center order-1 order-lg-2 d-none d-lg-block">
                            <div className="footer-logo">
                                <a href="/">
                                    <img src={logo} alt=""  style={{height:"100px"}}/>
                                </a>
                            </div>
                        </div>
                        {/* <div className="col-lg-4 d-none d-lg-block col-12">
                            <div className="scroll-up-btn text-md-right justify-content-end">
                                <a href="#top">
                                    <AiOutlineArrowUp />
                                </a>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer1;
